import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { NumberInput } from '../NumberInput/NumberInput.js';
import { Text } from '../Text/Text.js';
export const CurrencyInput = JSX((props) => (_jsx(NumberInput, { ...props, fractionDigits: 2, children: _jsx("div", { className: "absolute right-4 bottom-4", children: _jsx(Text, { size: "text-xl", font: "font-light", children: "\u20BD" }) }) })));
//# sourceMappingURL=CurrencyInput.js.map